module.exports = __webpack_public_path__ + "static/img/__2222.63129c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__2222.jpg
// module id = Xpjw
// module chunks = 0